import ilComponent from './AgentPair'

export default Vue => {
    Vue.component(ilComponent.name, ilComponent);
}
